<template>
  <div>
    <ul class="status">
      <li>
        <button
          @click="showModal('serial')"
          class="btn btn-sm btn-info mr-2 mb-2"
        >
          <span class="ti-plus"></span> Штрих
        </button>
      </li>
    </ul>
    <ul class="body_content">
      <li v-for="item in items" :key="item.id">
        <div class="row">
          <div class="col-12">
            <fg-input
              type="text"
              :label="'Название'"
              v-model="item.title"
            ></fg-input>
          </div>

          <div class="col-12">
              <checkbox  v-model="item.is_active" color="#ffc107">Активность</checkbox>
          </div>
          <div class="col-9">
            <fg-input
              type="text"
              :label="'Штрих'"
              v-model="item.serial_number"
            ></fg-input>
          </div>
          <div class="col-3">
            <fg-input
              type="numeric"
              :label="'Количество'"
              v-model="item.quantity"
            ></fg-input>
          </div>
          <div class="col-12">
            <button @click="saveItem(item)" class="btn btn-sm btn-success mr-2">
              <span class="ti-save"></span>
            </button>
            <button @click="removeItem(item)" class="btn btn-sm btn-danger">
              <span class="ti-trash"></span>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <add-item
      :onCreateOpen="false"
     :fieldsFrom="fields"
      :setLink="`${cardPushLink}?id=${id}`"
      :modalCreate="'serial'"
      :getList="getList"
       @input="push"
       :params="{}"
    />
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

export default {
  components: {
    "sub-field-list": () => import("../SubFieldList"),
    "add-item": () => import("./../../Modals/AddItem"),
  },
  data: () => ({
    cardLink: "products/serials/list",
    cardPushLink: "products/serials/add",
    cardRejectLink: "products/serials/delete",
    cardUpdateLink: "products/serials/update",
    showCreate: false,
    items: [],
    modal: "",
    selectData: {},
    fields: [
      {
        key: "is_active",
        label: "Активность",
        type: "checkbox",
        textType: "text",
      },
      {
        key: "title",
        label: "Название (уникальность)",
        type: "field",
        textType: "text",
      },
      {
        key: "serial_number",
        label: "Серийный номер",
        type: "field",
        textType: "text",
      },
      {
        key: "quantity",
        label: "Количество",
        type: "field",
        textType: "text",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.items = await this.cardContent(this.cardLink, this.id, "list");
  },
  methods: {
    cardContent: cardContent,
    cardUpdate: cardUpdate,
    getList() {
      //console.log('dsds')
      return true;
    },
    async push(val) {
      this.items.push(val);
    },
    showModal() {
      setTimeout(() => {
        this.$modal.show('serial');
      }, 10);
    },
    saveItem(item) {
      this.cardUpdate(
        `${this.cardUpdateLink}?id=${this.id}`,
        { item: item },
        "put"
      );
    },
    removeItem(item) {
      if (
        this.cardUpdate(
          `${this.cardRejectLink}?id=${this.id}`,
          { item: item },
          `delete`
        )
      ) {
        for (let i = 0; i < this.items.length; i++) {
          if (item.id === this.items[i].id) {
            this.items.splice(i, 1);
            break;
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
ul.body_content {
  list-style: none;
  margin: 0;
  padding: 0;
  & > li {
    background: #f2f2f2;
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 15px;
  }
}

.ql-editor {
  background: #fff;
}
</style>
